module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-215.e917838d.svg";